// This file contains the queries used with the Maps API
// but not all the queries used with the SQL API
// for those other queries, refer to apiService.js

export default {
  centers: 'SELECT * FROM eci_centros',
  centers_exclude: id => `SELECT * FROM eci_centros where center_id <> ${Number(id)}`,
  center_detail: `
  SELECT c.*,
    (
      SELECT COALESCE(ARRAY_AGG(code), ARRAY[]::text[]) 
      FROM eci_zonas_postal_codes WHERE center_id = c.center_id
    ) as postalcodes,
    (
      SELECT COALESCE(ARRAY_AGG(distinct code), ARRAY[]::text[])
      FROM eci_zonas_postal_codes WHERE code LIKE CONCAT(c.province_code::text, '%')
    ) as postalcodes_province,
    (
      SELECT COALESCE(ARRAY_AGG(geohash), ARRAY[]::text[]) 
      FROM eci_zonas_geohashes WHERE center_id = c.center_id
    ) as grids
  FROM "eci_centros" c
  `,
  grids: id => `
  SELECT g.* FROM master_geohash g
  JOIN eci_zonas_geohashes e
    ON e.geohash = g.code
    AND e.center_id = ${id}
  `,
  postalcodes: id => `
  SELECT p.* FROM master_postal p
  JOIN eci_zonas_postal_codes e
    ON e.code = p.code
    AND e.center_id = ${id}
  `,
  provinces: id => `
  SELECT pv.* FROM provinces pv
  JOIN eci_centros e
    ON e.province_code = pv.province_code
    AND e.center_id = ${id}
  `,
  competitors: ({ centerid, areatype, areas, categories = [], brands = [] }) => {
    const categoriesFilter = categories.length ? `category IN (${categories.join()})` : 'TRUE'
    const brandsFilter = brands.length ? `brandname IN (${brands.join()})` : 'TRUE'
    const joinTable = areatype === 'grids' ? 'eci_zonas_geohashes' : 'eci_zonas_postal_codes'
    const geomField = areatype === 'grids' ? 'geohash' : 'code'

    const joinClause = areas.length === 0
      ? `JOIN "${joinTable}" secondary ON secondary."${geomField}" = main."${geomField}" AND secondary.center_id = ${Number(centerid)}`
      : ''
    const whereClause = areas.length === 0
      ? `WHERE ${categoriesFilter} AND ${brandsFilter}`
      : `WHERE ${categoriesFilter} AND ${brandsFilter} AND "${geomField}"::text IN(${areas.map(a => `$$${a}$$`).join(',')})`

    return `SELECT main.* FROM eci_poi_competencia main ${joinClause} ${whereClause}`
  }
}
